import { artwork } from "@/assets/categories";
import { borderWidth, colors, spacings } from "@/assets/themes";
import {
  Block,
  Body14,
  Body16,
  Button,
  Card,
  H5,
  Icon,
  List,
} from "@/components";
import { BUTTON, LIST } from "@/components/Styles/variants";
import { useBreakpoints, useLocalStorage } from "@/modules/hooks";
import { getCategoryFormUrlById } from "@/utils";
import polyglot from "@/utils/polyglot";
import { useState } from "react";

const Content = ({ categoryId, onRemove }) => (
  <>
    <H5 strong>
      {polyglot.t("home.resume_form_title", {
        title: polyglot.t(`categories.${categoryId}.name`),
      })}
    </H5>
    <Body14>{polyglot.t("home.resume_form_description")}</Body14>
    <Block display="flex" gap={spacings.s} marginTop={spacings.s}>
      <Button.Small
        shape={BUTTON.SHAPE.PILL}
        kind={BUTTON.KIND.SECONDARY}
        href={getCategoryFormUrlById(categoryId)}
      >
        {polyglot.t("common.resume")}
      </Button.Small>
      <Button.Small
        shape={BUTTON.SHAPE.CIRCLE}
        accentColor={BUTTON.ACCENT_COLOR.BODY}
        kind={BUTTON.KIND.SECONDARY}
        onClick={onRemove}
      >
        <Icon.Medium name="trash" color={colors.muted} />
      </Button.Small>
    </Block>
  </>
);

const HomeResumeForm = () => {
  const breakpoints = useBreakpoints();
  const [resumeForm, _, remove] = useLocalStorage("category-form", []);
  const [categoryId, setCategoryId] = useState(
    resumeForm ? Object.keys(resumeForm)[0] : null
  );

  const handleRemove = () => {
    remove();
    setCategoryId(null);
  };

  if (!categoryId) return null;

  return (
    <Block marginTop={spacings.m}>
      {breakpoints.get({
        xs: (
          <Card
            headerImage={artwork[categoryId]}
            withGutters
            css={`
              border: solid ${borderWidth.s} ${colors.border};
            `}
          >
            <Content categoryId={categoryId} onRemove={handleRemove} />
          </Card>
        ),
        md: (
          <Block
            border={`solid ${borderWidth.s} ${colors.border}`}
            borderRadius={spacings.m}
            display="flex"
            flexDirection="row"
            alignItems="stretch"
            gap={spacings.s}
            overflow="hidden"
          >
            <Block
              flex="1"
              padding={spacings.ml}
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              <Content categoryId={categoryId} onRemove={handleRemove} />
            </Block>
            <Block
              flex="1"
              css={`
                background-image: url(${artwork[categoryId]});
                background-size: cover;
                background-position: center;
              `}
            />
          </Block>
        ),
      })}
    </Block>
  );
};

export default HomeResumeForm;
